<!-- 历史库存记录 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline dis" size="mini">
                    <el-form-item label="通用名称">
                        <el-input v-model.trim="getRequestData.bgmName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="开始日期">
                        <el-date-picker size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期">
                        <el-date-picker size="mini" v-model="getRequestData.end" @change="changeTime" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchData">查询</el-button>
                        <el-button type="primary" size="mini" icon="el-icon-share" @click="exportExcel">导出</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-tabs>
            <el-tab-pane label="流水信息">
                <div class="page_content_center">
                    <el-table size="mini" id="tableData" :data="returnData.list" height="100%" border style="width: 100%" show-summary :summary-method=" getSummaries" stripe ref="stockTable" :header-cell-style="{background:'#fff'}">
                        <el-table-column show-overflow-tooltip prop="bgmCode" label="商品编码" width="150px" :sortable="true"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="bgmName" label="通用名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="bgiGename" label="通用名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="manufacturer" label="生产商"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="placeorigin" label="产地"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="spec" label="规格"></el-table-column>
                        <el-table-column show-overflow-tooltip label="期初" align="center">
                            <el-table-column show-overflow-tooltip prop="inItCount" label="数量" :sortable="true"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="inItMoney" label="金额" :sortable="true"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="入库" align="center">
                            <el-table-column show-overflow-tooltip prop="inCount" label="数量" :sortable="true"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="inMoney" label="金额" :sortable="true"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="出库" align="center">
                            <el-table-column show-overflow-tooltip prop="outCount" label="数量" :sortable="true"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="outMoney" label="金额" :sortable="true"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="期末" align="center">
                            <el-table-column show-overflow-tooltip prop="endCount" label="数量" :sortable="true"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="endMoney" label="金额" :sortable="true"></el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div> -->
    </div>
    </template>
    
    <script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    import FileSaver from "file-saver";
    import XLSX from "xlsx";
    export default {
        name: "dataQueryTemplate",
        //import引入的组件需要注入到对象中才能使用
        data() {
            //这里存放数据
            return {
                getRequestData: {
                    bgmName: '', //	通用名称
                    start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                    end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                },
                activeName: "0",
                returnData: {
                    pages: 0, // 总页数
                    total: 0, // 总条数
                    pageNum: 0, // 当前页数
                    list: [],
                },
                selectedDataIndex: 0,
                reportConditionVos: [],
                reportModuleVos: [],
                tabIndex: 0,
                total: null,
                totalPageData: [],
                // 共几页
                pageNum: 1,
                // 每页显示数量
                pageSize: 10,
                // 当前显示页码
                currentPage: 1,
                // 总共多少条数据
                total: 1,
                // 当前要显示的数据
                pageSizes: [],
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //方法集合
        methods: {
            //获取当天最后时间戳
            changeTime(val) {
                if (val) {
                    var time = val + 24 * 60 * 60 * 1000 - 1
                    this.getRequestData.end = time
                }
            },
            toDetail(orderId) {
                console.log(orderId);
                this.$parent.toDetail(orderId);
                //    this.$parent.$parent.$parent.toDetail(orderId)
            },
            //定义导出Excel表格事件
            exportExcel() {
                var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换
                /* 从表生成工作簿对象 */
                var wb = XLSX.utils.table_to_book(
                    document.querySelector("#tableData"),
                    xlsxParam
                );
                // var wb = XLSX.utils.table_to_book(document.querySelector("#exTable"))
                /* 获取二进制字符串作为输出 */
                var wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array",
                });
                try {
                    FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], { type: "application/octet-stream" }),
                    //设置导出文件名称
                    "历史库存.xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined") console.log(e, wbout);
                }
                return wbout;
            },
            //   查询
            searchData() {
                this.getDataList()
            },
            //定义导出Excel表格事件
            exportExcel() {
                var xlsxParam = {
                    raw: true
                }; // 导出的内容只做解析，不进行格式转换
                /* 从表生成工作簿对象 */
                var wb = XLSX.utils.table_to_book(
                    document.querySelector("#tableData"),
                    xlsxParam
                );
                // var wb = XLSX.utils.table_to_book(document.querySelector("#exTable"))
                /* 获取二进制字符串作为输出 */
                var wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array",
                });
                try {
                    FileSaver.saveAs(
                        //Blob 对象表示一个不可变、原始数据的类文件对象。
                        //Blob 表示的不一定是JavaScript原生格式的数据。
                        //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                        //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        //设置导出文件名称
                        "报表查询.xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined") console.log(e, wbout);
                }
                return wbout;
            },
            //表格求和
            getSummaries(param) {
                const {
                    columns,
                    data
                } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    } else if (index >= 5) {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            // sums[index] += ' 元';
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                });
                this.$nextTick(() => {
                    this.$refs.stockTable.doLayout()
                })
                return sums;
            },
    
            // 获取数据列表
            async getDataList() {
                let responseData = await this.$http.getCollOfficeHistoryStockInfo(
                    this.getRequestData
                );
                if (responseData.status == 200) {
                    this.returnData.list = responseData.result
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            },
    
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {
            this.getDataList();
        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {},
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    };
    </script>
    
    <style scoped>
    .table_content_tag {
        margin-right: 1rem;
    }
    
    .el-tabs--border-card_new {
        height: 85vh;
        overflow-y: scroll;
    }
    
    .el-drawer {
        outline: none;
    }
    
    .page_content_center {
        height: 78vh;
        overflow-y: auto;
    }
    
    .dis {
        display: flex;
        flex-wrap: wrap !important;
    }
    
    .el-table thead.is-group th {
        background: '#fff';
    }
    </style>
    